import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _objectSpread from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { validateor, validateInfo } from '@/utils/validate';
import { Vue, Component, Ref } from 'vue-property-decorator';
import SchdulePlan from '@/modules/SchdulePlan/index.vue';
import BreadcrumbHeader from '@/views/Layout/BreadcrumbHeader.vue';
import apis from '@/apis/scheduleManage';

var ScheduleUpdate = /*#__PURE__*/function (_Vue) {
  _inherits(ScheduleUpdate, _Vue);

  var _super = _createSuper(ScheduleUpdate);

  function ScheduleUpdate() {
    var _this;

    _classCallCheck(this, ScheduleUpdate);

    _this = _super.call(this);
    _this.allSchedule = [];
    _this.loading = false;
    _this.personList = [];
    _this.confMemberList = [];
    _this.confMemberMax = 6;
    _this.caseId = null;
    _this.scheduleId = null;
    _this.form = {
      chiefJudgeId: '',
      clerkId: '',
      confMember: []
    };
    _this.rule = {
      chiefJudgeId: validateor({
        required: true,
        trigger: 'change'
      }),
      clerkId: [],
      confMember: [{
        required: true,
        message: validateInfo.required,
        trigger: 'change',
        type: 'array'
      }]
    };
    _this.submitLoad = false;
    _this.pickerOptions = {
      disabledDate: function disabledDate(time) {
        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
      }
    };
    _this.scheduleInfo = {
      relationList: [],
      chiefJudgeId: '',
      clerkId: '',
      caseIndexCodeList: []
    };
    _this.selectInfo = {
      planStartTime: '',
      planEndTime: '',
      tribunalName: '',
      tribunalId: ''
    };
    _this.date = new Date(Date.now() + 24 * 60 * 60 * 1000);
    _this.searchStartTime = _this.$moment(_this.date).format('YYYY-MM-DD 00:00:00');
    _this.searchEndTime = _this.$moment(_this.date).format('YYYY-MM-DD 23:59:59');
    return _this;
  } // 页面状态是否在编辑状态


  _createClass(ScheduleUpdate, [{
    key: "getPersonList",
    // 获取人员信息
    value: function getPersonList() {
      var _this2 = this;

      apis.newUserList().then(function (res) {
        _this2.personList = res.data || [];
      }).then(function (_) {});
    } // 获取案件当事人信息

  }, {
    key: "getPartyList",
    value: function getPartyList() {
      var _this3 = this;

      apis.getInPersonInfos({
        caseId: this.caseId
      }).then(function (res) {
        _this3.confMemberList = res.data.all || []; // res.data.defendants.concat(res.data.plaintiffs).concat(res.data.thirds)

        if (!_this3.scheduleId) {
          var phones = _this3.confMemberList.map(function (item) {
            return item.phoneNo;
          });

          if (phones.length > 6) {
            _this3.form.confMember = phones.splice(0, 6);
          } else {
            _this3.form.confMember = phones;
          }
        }
      }).then(function (_) {});
    }
  }, {
    key: "confMemberChange",
    value: function confMemberChange(val) {// console.log('参审人员变更', val)
    } // 保存

  }, {
    key: "onSubmit",
    value: function onSubmit() {
      var _this4 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (!_this4.submitLoad) {
            _this4.submitLoad = true;

            if (_this4.isEdit) {
              _this4.updateSchedule();
            } else {
              _this4.saveSchedule();
            }
          }
        }
      });
    } // 取消

  }, {
    key: "onCancel",
    value: function onCancel() {
      this.$router.go(-1);
    } // 获取保存排期数据

  }, {
    key: "getSaveParams",
    value: function getSaveParams() {
      var _this$selectInfo = this.selectInfo,
          planStartTime = _this$selectInfo.planStartTime,
          planEndTime = _this$selectInfo.planEndTime,
          tribunalId = _this$selectInfo.tribunalId,
          tribunalName = _this$selectInfo.tribunalName;
      var _this$form = this.form,
          clerkId = _this$form.clerkId,
          chiefJudgeId = _this$form.chiefJudgeId,
          confMember = _this$form.confMember;
      var date = this.date; // 判断审判长和书记员是否选择同一人

      if (clerkId === chiefJudgeId) {
        this.$message("".concat(this.showNameMap.judge, "\u548C").concat(this.showNameMap.clerk, "\u4E0D\u80FD\u4E3A\u540C\u4E00\u4EBA"));
        return false;
      } // 判断排期时间不能早于今天


      if (this.$moment(date).isBefore(new Date(), 'day')) {
        this.$message('排期时间不能早于今天');
        return false;
      } // 判断开始时间和结束时间是否为空


      if (!planStartTime || !planEndTime) {
        this.$message('排期时间不能为空');
        return false;
      }

      var params;
      params = _objectSpread(_objectSpread({}, this.form), {}, {
        confMember: confMember.join(','),
        planDate: this.$moment(this.date).format('YYYY-MM-DD'),
        courtNo: this.$store.getters.userInfo.courtNo,
        caseIndexCodeList: this.isEdit ? this.scheduleInfo.caseIndexCodeList : new Array(this.caseId),
        planStartTime: planStartTime,
        planEndTime: planEndTime,
        tribunalId: tribunalId,
        tribunalName: tribunalName
      });

      if (this.isEdit) {
        params = _objectSpread(_objectSpread({}, params), {}, {
          scheduleId: this.scheduleId
        });
      }

      return params;
    } // 获取排期详情

  }, {
    key: "getScheduleDetail",
    value: function getScheduleDetail() {
      var _this5 = this;

      apis.scheduleById({
        scheduleId: this.scheduleId
      }).then(function (res) {
        _this5.scheduleInfo = res.data;
        var _res$data = res.data,
            chiefJudgeId = _res$data.chiefJudgeId,
            clerkId = _res$data.clerkId,
            planDate = _res$data.planDate,
            planStartTime = _res$data.planStartTime,
            planEndTime = _res$data.planEndTime,
            tribunalName = _res$data.tribunalName,
            tribunalId = _res$data.tribunalId,
            confMember = _res$data.confMember,
            caseId = _res$data.caseId;
        _this5.form = {
          chiefJudgeId: chiefJudgeId,
          clerkId: clerkId,
          confMember: confMember ? confMember.split(',') : []
        };
        _this5.searchStartTime = _this5.$moment(planDate).format('YYYY-MM-DD 00:00:00');
        _this5.searchEndTime = _this5.$moment(planDate).format('YYYY-MM-DD 23:59:59');
        _this5.date = planDate;

        _this5.getAllSchedule();

        _this5.caseId = caseId;
        _this5.selectInfo = {
          planStartTime: planStartTime,
          planEndTime: planEndTime,
          tribunalName: tribunalName,
          tribunalId: tribunalId
        };

        _this5.getPartyList();
      }).catch(function (_) {});
    } // 保存排期

  }, {
    key: "saveSchedule",
    value: function saveSchedule() {
      var _this6 = this;

      var params = this.getSaveParams();

      if (params) {
        apis.save(params).then(function (res) {
          _this6.$message.success('新建排期成功');

          _this6.$router.go(-1);
        }).catch(function (_) {
          _this6.submitLoad = false;
        });
      } else {
        this.submitLoad = false;
      }
    } // 更新排期

  }, {
    key: "updateSchedule",
    value: function updateSchedule() {
      var _this7 = this;

      var params = this.getSaveParams();

      if (params) {
        apis.update(this.getSaveParams()).then(function (res) {
          _this7.$message.success('修改排期成功');

          _this7.$router.go(-1);
        }).catch(function (_) {
          _this7.submitLoad = false;
        });
      } else {
        this.submitLoad = false;
      }
    } // 获取全部排期

  }, {
    key: "getAllSchedule",
    value: function getAllSchedule() {
      var _this8 = this;

      this.loading = true;
      var params = {
        pageSize: 10000,
        pageNo: 1,
        searchDateStart: this.searchStartTime,
        searchDateEnd: this.searchEndTime,
        scheduleId: this.isEdit ? this.scheduleId : ''
      };
      apis.allSchedule(params).then(function (res) {
        _this8.allSchedule = res.data.list || [];
        _this8.loading = false;
      }).catch(function (_) {
        _this8.loading = false;
      });
    }
  }, {
    key: "chooseTime",
    value: function chooseTime(params) {
      var tribunalId = params.tribunalId,
          tribunalName = params.tribunalName,
          startTimeObj = params.startTimeObj,
          endTimeObj = params.endTimeObj;
      this.selectInfo = {
        planStartTime: startTimeObj.time,
        planEndTime: endTimeObj.time,
        tribunalId: tribunalId,
        tribunalName: tribunalName
      };
    }
  }, {
    key: "resetSelectInfo",
    value: function resetSelectInfo() {
      this.selectInfo = {
        planStartTime: '',
        planEndTime: '',
        tribunalName: '',
        tribunalId: ''
      };
    }
  }, {
    key: "chooseStart",
    value: function chooseStart() {
      this.resetSelectInfo();
    } // 更新日期

  }, {
    key: "dateChange",
    value: function dateChange(val) {
      this.date = val;
      this.searchStartTime = this.$moment(val).format('YYYY-MM-DD 00:00:00');
      this.searchEndTime = this.$moment(val).format('YYYY-MM-DD 23:59:59');
      this.getAllSchedule();
      this.resetSelectInfo();
      this.schdulePlan.reset();
    }
  }, {
    key: "created",
    value: function created() {
      this.scheduleId = this.$route.params.scheduleId;
      this.caseId = this.$route.params.caseId;
      this.getPersonList();

      if (this.scheduleId) {
        this.getScheduleDetail();
      } else {
        this.getAllSchedule();
        this.form.chiefJudgeId = this.$store.getters.userInfo.userId;
        this.getPartyList();
      }
    }
  }, {
    key: "isEdit",
    get: function get() {
      return !!this.scheduleId;
    }
  }, {
    key: "breadcrumbMessage",
    get: function get() {
      return this.isEdit ? '' : '新增排期';
    }
  }, {
    key: "showNameMap",
    get: function get() {
      return this.$store.getters.showNameMap;
    }
  }, {
    key: "selectMessage",
    get: function get() {
      var _this$selectInfo2 = this.selectInfo,
          planStartTime = _this$selectInfo2.planStartTime,
          planEndTime = _this$selectInfo2.planEndTime,
          tribunalName = _this$selectInfo2.tribunalName;

      if (planStartTime && planEndTime && tribunalName) {
        return "".concat(planStartTime, "~").concat(planEndTime, "  ").concat(tribunalName);
      }

      return '';
    }
  }, {
    key: "caseInfo",
    get: function get() {
      return this.scheduleInfo.relationList && this.scheduleInfo.relationList.length ? this.scheduleInfo.relationList[0] : {
        caseId: ''
      };
    }
  }]);

  return ScheduleUpdate;
}(Vue);

__decorate([Ref('schdulePlan')], ScheduleUpdate.prototype, "schdulePlan", void 0);

ScheduleUpdate = __decorate([Component({
  components: {
    SchdulePlan: SchdulePlan,
    BreadcrumbHeader: BreadcrumbHeader
  }
})], ScheduleUpdate);
export default ScheduleUpdate;